<template>
  <div>
    <PageTitle :route="$route">
      <template slot="action-button">
        <ActionButton
          icon="fa-plus"
          v-on:click="onClickButton"
        />
      </template>
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <UsersList />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import UsersList from '@/components/settings/users/users/UsersList'
import ActionButton from '@/components/button/ActionButton'

export default {
  name: 'Users',
  components: {
    PageTitle,
    ActionButton,
    PageRowWrapper,
    UsersList
  },
  methods: {
    onClickButton (e) {
      this.$router.push({ name: 'addusers' })
    }
  }
}
</script>
